<a 
	class="page-card" 
	queryParamsHandling="preserve" 
	[routerLink]="getUrl(item)" 
	matRipple 
	>

	<div 
		class="thumbnail-wrapper" 
		*ngIf="item.fieldPoster !== undefined"
		>

		<app-media 
			*ngIf="item.entityBundle !== 'partners'" 
			class="page-thumbnail big" 
			kind="card_big"
			[alt]="item.entityLabel"
			[src]="item.fieldPoster.url"
		></app-media>

		<app-card-logo 
			class="page-thumbnail logo" 
			[article]="item"
			*ngIf="item.entityBundle === 'partners'"
		></app-card-logo>
	</div>

	<span class="card-header">
		<h2 class="title" >{{item.entityLabel}}</h2>

		<span 
			[ngClass]="item.field_logo_1 ? 'logo' : 'no-logo'"
		>
			<app-card-logo 
				class="detail-thumbnail logo-partner" 
				[article]="item" 
				*ngIf="item.entityBundle !== 'partners' && item.field_logo_1"
			></app-card-logo>
			<h3 class="sub-title" >{{ item.fieldSubtitle }}</h3>
		</span>

		<!-- <h3 class="sub-title" *ngIf="item.fieldSubtitle" >{{item.fieldSubtitle}}</h3> -->
		<p class="description" *ngIf="kind !== 'home'" >{{item.fieldShortDescription}}</p>
		<span class="description" *ngIf="kind === 'home'" [innerHtml]="item.description.value"></span>
	</span>
</a>